import { createSimulationServices } from '@exodus/web3-simulation';
import { DEFAULT_CONFIG } from './constants';
export class TxSimulator {
    #assetsModule;
    #logger;
    #simulateSolanaTransactions;
    #simulateEthereumTransactions;
    constructor({ assetsModule, assetClientInterface, logger, config = {} }) {
        this.#assetsModule = assetsModule;
        this.#logger = logger;
        const { simulateSolanaTransactions, simulateEthereumTransactions } = createSimulationServices({
            apiBaseURL: config.apiUrl || DEFAULT_CONFIG.apiUrl,
            assetClientInterface,
        });
        this.#simulateEthereumTransactions = simulateEthereumTransactions;
        this.#simulateSolanaTransactions = simulateSolanaTransactions;
    }
    async simulate(params) {
        const { assetName, ...rest } = params;
        const asset = this.#assetsModule.getAsset(assetName);
        if (asset.baseAsset.api.web3?.simulateTransactions) {
            return asset.baseAsset.api.web3.simulateTransactions(params);
        }
        if (asset.baseAssetName === 'solana') {
            return this.#simulateSolanaTransactions({
                asset: asset.baseAsset,
                ...rest,
            });
        }
        if (asset.baseAsset.assetType === 'ETHEREUM_LIKE') {
            return this.#simulateEthereumTransactions({ ...rest });
        }
        this.#logger.warn(`No simulation service available for ${asset.name}`);
    }
}
const txSimulatorFactory = (args) => new TxSimulator({ ...args });
const txSimulatorDefinition = {
    id: 'txSimulator',
    type: 'module',
    factory: txSimulatorFactory,
    dependencies: ['assetsModule', 'logger', 'assetClientInterface', 'config?'],
    public: true,
};
export default txSimulatorDefinition;
